import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

Modal.setAppElement('#eautismiliitto-app');

const modalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        margin: 'auto',
        width: '80%',
        maxWidth: '600px',
        height: 'auto',
        border: 'none',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible'
    }
};

const PWDModal = ({ modal_content, texts, show_open_button = true, close_button_text = texts.summary_close_modal_text, white_bg }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const saveStrategyLinkRef = useRef(null);

    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };

    useEffect(() => {
        if (white_bg) {
            modalStyles.content.background = '#fff';
            modalStyles.content.padding = '32px';
            modalStyles.content.borderRadius = '32px';
        } else {
            modalStyles.content.background = '#000';
            modalStyles.content.padding = '24px 12px';
            modalStyles.content.borderRadius = '0';
        }
    }, [white_bg]);

    useEffect(() => {
        const saveStrategyLink = document.querySelector('.save-strategy');
        saveStrategyLinkRef.current = saveStrategyLink;

        if (saveStrategyLink) {
            saveStrategyLink.addEventListener('click', openModal);
        }

        return () => {
            if (saveStrategyLinkRef.current) {
                saveStrategyLinkRef.current.removeEventListener('click', openModal);
            }
        };
    });

    return (
        <>
            {show_open_button && (
                <button className="watch-video" onClick={openModal}>{texts.statement_watch_video_text}</button>
            )}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Video"
                style={modalStyles}
            >
                {modal_content ? (
                    parse(modal_content)
                ) : (
                    <>
                        <h2>{texts.summary_modal_title}</h2>
                        <p>{texts.summary_modal_text}</p>
                        <div class="buttons" style={{display: 'flex', alignItems: 'center', gap: '2rem', marginTop: '2rem'}}>
                            <Link className="modal-choose-other-topic" to="/topics">{texts.general_choose_other_topic_text}</Link>
                            <Link to={texts.general_site_url}>{texts.general_site_name}</Link>
                        </div>
                    </>
                )}
                <button onClick={closeModal} style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '0',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                    color: '#fff',
                    fontSize: '1rem',
                    textDecoration: 'underline',
                    fontFamily: 'Open Sans',
                    fontWeight: 600
                }}>
                    {close_button_text}
                    <img alt="" style={{ height: '28px', width: '28px', marginLeft: '.75rem' }} src={texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/circle-close.png'} />
                </button>
            </Modal>
        </>
    );
};

export default PWDModal;
